<html>
<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css">
</head>

<body>
    <button class="border-0 bg-dark">
        <i class="fa fa-redo"></i>

    </button>
</body>
</html>